import React from 'react'
import type { AssetSource } from 'EditorApp/types'

interface Props {
  source: AssetSource
  style: React.CSSProperties
}

const sourceTypeFor = (contentType: string): string => {
  if (contentType === 'video/quicktime') {
    return 'video/mp4; codecs="hvc1"'
  }

  if (contentType === 'video/mp4') {
    return 'video/mp4; codecs="avc1"'
  }

  return contentType
}

const formatUrl = (assetUrl: string, extension: string): string => {
  const ext = extension.replace(/^\./, '')
  return `${assetUrl}.${ext}`
}

const VideoWithSources = ({ source, style }: Props) => {
  return (
    <video autoPlay loop muted playsInline style={style} draggable="false">
      {source.formats.map((format) => {
        const url = formatUrl(source.url, format.extension)

        return (
          <source
            key={url}
            src={url}
            type={sourceTypeFor(format.contentType)}
          />
        )
      })}
    </video>
  )
}

export default VideoWithSources
